var _defs, _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBedsIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 24,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "beds-icon_svg__a",
    d: "M0 0h43.322v24H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "beds-icon_svg__b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#beds-icon_svg__a"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1.617 20.545h40.089v-6.633H1.617v6.633zm40.897 1.617H.808A.809.809 0 010 21.353v-8.25c0-.447.362-.808.808-.808h41.706c.447 0 .808.361.808.808v8.25a.808.808 0 01-.808.809z",
    fill: "currentColor",
    mask: "url(#beds-icon_svg__b)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.816 21.122H3.905a.232.232 0 00-.232.231v2.416c0 .127.104.231.232.231h2.911a.231.231 0 00.231-.23v-2.417a.231.231 0 00-.231-.23M39.785 21.122h-2.911a.232.232 0 00-.232.231v2.416c0 .127.104.231.232.231h2.91a.231.231 0 00.232-.23v-2.417a.231.231 0 00-.231-.23M5.709 8.937h31.905v-7.32H5.709v7.32zm32.713 1.617H4.9a.809.809 0 01-.809-.809V.809C4.091.362 4.453 0 4.9 0h33.522c.447 0 .809.362.809.809v8.936a.809.809 0 01-.809.809z",
    fill: "currentColor",
    mask: "url(#beds-icon_svg__b)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.045 12.295h35.234v-1.741H4.045v1.741zm36.042 1.617H3.236a.81.81 0 01-.809-.809V9.745c0-.447.363-.808.809-.808h36.851c.447 0 .809.361.809.808v3.358a.809.809 0 01-.809.809z",
    fill: "currentColor",
    mask: "url(#beds-icon_svg__b)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.928 9.283h10.029V3.859H9.928v5.424zm10.492.924H9.466a.462.462 0 01-.462-.462V3.397c0-.255.208-.462.462-.462H20.42c.255 0 .462.207.462.462v6.348a.462.462 0 01-.462.462zM22.766 9.283h10.029V3.859H22.766v5.424zm10.491.924H22.304a.46.46 0 01-.462-.462V3.397c0-.255.206-.462.462-.462h10.953c.256 0 .462.207.462.462v6.348a.46.46 0 01-.462.462z",
    fill: "currentColor",
    mask: "url(#beds-icon_svg__b)"
  }))));
}

export default SvgBedsIcon;